import { ScrollPanel } from '@assets/component/Panel/ScrollPanel/ScrollPanel';
import { useStore } from '@assets/model/Store';
import { get, getDatabase, onValue, ref } from 'firebase/database';
import { marked } from 'marked';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import moment from 'moment';

export const DealFlowiseProfile = observer(() => {
    const store = useStore();
    const [reportData, setReportData] = useState(null);

    useEffect(() => {
        const companyId = 'profile_aqualisco';
        const report_type = 'build_company_profile';
        const target = `report_runs/${report_type}/${companyId}`;
        const r = ref(getDatabase(), target);
        const unsub = onValue(r, data => {
            setReportData(data.val());
        });

        return () => unsub();
    }, []);

    var run_variables = [];

    if (reportData?.vars) {
        const runVars = reportData.vars;
        let keys = Object.keys(runVars).sort();
        const parseData = s => {
            return moment(s.slice(0, 23));
        };

        keys.sort((a, b) => {
            const aDate = parseData(runVars[a]['updated_at']);
            const bDate = parseData(runVars[b]['updated_at']);
            return bDate.valueOf() - aDate.valueOf();
        });

        for (let k of keys) {
            const rawHtmlWithDefault = marked.parse(
                runVars[k]['value'] as string
            ) as string;

            const updatedAt = runVars[k]['updated_at'];
            const date = moment(updatedAt.slice(0, 23));

            let sanitizedHtml = DOMPurify.sanitize(
                rawHtmlWithDefault as string
            );
            run_variables.push(
                <tr key={k} style={{ borderTop: '1px solid #ccc' }}>
                    <td valign="top">{k}</td>
                    <td>
                        <div
                            style={{ maxWidth: '1200px' }}
                            dangerouslySetInnerHTML={{
                                __html: sanitizedHtml
                            }}
                        />
                    </td>
                    <td valign="top">{date.format('YYYY-MM-DD HH:mm:ss')}</td>
                </tr>
            );
        }
    }
    return (
        <ScrollPanel>
            <h1>Run Variables</h1>
            <table style={{ top: '50px', position: 'relative' }}>
                <tbody>{run_variables}</tbody>
            </table>
        </ScrollPanel>
    );
});
